export const LATEST_CHECKOUT_EXPERIENCE = {
  key: 'LATEST_CHECKOUT_EXPERIENCE',
  BAB: 'BAB',
  SHOP: 'SHOP'
};
